export const REACT_STYLE_BUTTON_SIZE_DESKTOP = "20px";
export const REACT_STYLE_BUTTON_SIZE_MOBILE = "13px";



// WEBPACK FOOTER //
// ./src/pages/Constants.js